import React from 'react';
import FloatingContact from '../FloatingContact/FloatingContact';

export default function FloatingCallButton(props) {
  return <FloatingContact {...props} />;
}
